module.exports = __webpack_public_path__ + "img/Platform_Gradients-8.6a4fd905.jpg";